// extracted by mini-css-extract-plugin
export default {"cls1":"AgilysysLogo_cls1__CEvuR","cls2":"AgilysysLogo_cls2__6qLFM"};